import React from 'react'
import "./PBReport.css"
const PBReport = (props) => {
    let { url } = props;
    return (
        <div className='PBreportContainer'>
            <iframe
                className={"PBframe"}
                src={url}
                frameborder="0"
                allowFullScreen="true"
            />
        </div>
    )
}

export default PBReport